import React, { Component } from 'react';

export default class Color extends Component {
  render() {
    const style = {
      height: '34px',
      border: '1px solid #ccc',
      borderRadius: '4px',
      backgroundColor: this.props.option || 'rgb(246, 246, 246)',
    };
    return (
      <div className="col" style={style}></div>
    );
  }
};



// WEBPACK FOOTER //
// ./src/common/Color/index.js